export const MARKETPLACE_CATEGORIES = [
  'All',
  'Bundles',
  'Business',
  'Self-Help',
  'AI & Technology',
  'Fitness',
  'Marketing',
  'Finance',
  'Personal Development',
  'Health',
  'Productivity',
  'Travel',
];

export const getMarketplaceCategorySlug = (category: string) => category
  .toLowerCase()
  .replace(/&/g, 'and')
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-|-$/g, '');

export const MARKETPLACE_CATEGORY_SLUGS = MARKETPLACE_CATEGORIES
  .filter((category) => category !== 'All')
  .map((category) => ({ category, slug: getMarketplaceCategorySlug(category) }));

export const getMarketplaceCategoryBySlug = (slug: string) =>
  MARKETPLACE_CATEGORY_SLUGS.find((item) => item.slug === slug)?.category;

export const getMarketplaceCategoryPath = (category: string) =>
  category === 'All' ? '/marketplace' : `/marketplace/${getMarketplaceCategorySlug(category)}`;
